export const galleyImageOptions = {
  angle: 'galley',
  staticOptions: {
    Veneer: 1,
    Floorboard: 1,
    Handrail: 1,
    Fabric: 1,
    CupboardsSaloon: 1,
    CupboardsOwnersCabin: 1,
    FabricOwnersCabin: 1,
    FabricAftCabin: 1,
    AftCabinLayout: 1,
    Mast: 1
  },
  mattes: [
    {
      option: 'Veneer',
      dependency: null
    },
    {
      option: 'Floorboard',
      dependency: null
    },
    {
      option: 'Handrail',
      dependency: 'Veneer'
    },
    {
      option: 'Fabric',
      dependency: 'Worktop'
    },
    {
      option: 'CupboardsSaloon',
      dependency: 'Veneer'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X43MK2/views/galley.js